/**
 * KPIs forenses do Centro de conformidade (DPO) — derivados da própria lista de
 * ConflictAlert (o DPO não tem `conflict-alert-metrics-read`, então não pode chamar
 * `GET /conflict-alerts/metrics`). Helper puro. Espelha a copy do mockup B3
 * (`design-references/brief-5/r1/conformidade.html`): Critical/High/Total pendentes
 * + Resolvidos.
 */
import type { ConflictAlertVM } from '../../supervisor/view-models';

/** Status terminais do ConflictAlert (lifecycle ADR-117 — `auto_resolved` incluso). */
const TERMINAL_STATUSES = new Set(['resolved', 'revoked', 'false_positive', 'auto_resolved']);

export function isTerminalStatus(status: string): boolean {
  return TERMINAL_STATUSES.has(status);
}

export interface ForensicKpis {
  criticalPending: number;
  highPending: number;
  totalPending: number;
  resolved: number;
}

export function deriveForensicKpis(alerts: ConflictAlertVM[]): ForensicKpis {
  const kpis: ForensicKpis = {
    criticalPending: 0,
    highPending: 0,
    totalPending: 0,
    resolved: 0,
  };
  for (const a of alerts) {
    if (isTerminalStatus(a.status)) {
      kpis.resolved += 1;
      continue;
    }
    kpis.totalPending += 1;
    if (a.severity === 'critical') kpis.criticalPending += 1;
    else if (a.severity === 'high') kpis.highPending += 1;
  }
  return kpis;
}
